// extracted by mini-css-extract-plugin
export var formContainer = "_l9-0";
export var message = "_l9-1";